'use strict'

// import state from './state'

// getters
const getters = {
	entryUrl: state => state.entryUrl,
	allProducts: state => state.all, // would need action/mutation if data fetched async
	cartProducts: state => {
		// return state.addedProducts.map(({ sku, quantity }) => {
		// 	const product = state.productsList.find(p => p.sku === sku)
		//
		// 	return {
		// 		sku,
		// 		name: product.name,
		// 		price: product.price,
		// 		quantity
		// 	}
		// })
		return state.addedProducts
	}
}

export default getters



// WEBPACK FOOTER //
// ./src/common/store/getters.js